import React from "react";
import PanelBody from "./body";
import { Header } from "../header";
import { AppMainMenu } from "../menu";
import NotificationBlock from "../../components/notifications/block";
import { version } from "../../constants/config";
import { CallContainer, CallButton } from "../../components/call";

const expSelector = "?exp";

const PanelPage = ({ children }) => {
  const isExperimental = expSelector === window.location.search;

  return (
    <div className="app panelPage">
      <Header />
      <AppMainMenu />
      <NotificationBlock />
      <PanelBody>{children}</PanelBody>
      <div className="versionText">{version}</div>
      {isExperimental && (
        <CallContainer>
          <CallButton />
        </CallContainer>
      )}
    </div>
  );
};

export default PanelPage;
